<template>
  <li class="board__item pnt" @click="goDetail">
    <div class="txt_wrap">
      <span class="new" v-if="isNew()">
        <img :src="require(`@/assets/front/images/i_new2.svg`)" alt="" />
      </span>
      <p class="txt" v-html="colorWord(data.title)"></p>
    </div>
  </li>
</template>
<script>
import { setKeyword, checkNewPost } from '@common/lib/common/utils';

export default {
  name: 'component-search-board-item',
  description: '검색 페이지 > 게시판 아이템',
  props: {
    data: Object,
    type: String,
  },
  methods: {
    goDetail() {
      const id = this.data.id;
      if (this.type === 'BOARD') {
        this.$router.push({
          name: 'Board.Detail',
          params: { id: id, isRead: 'Y' },
        });
      } else {
        this.$router.push({
          name: 'Knowhow.Detail',
          params: { id: id, isRead: 'Y' },
        });
      }
    },
    colorWord(content) {
      const keyword = this.$route.query.keyword;
      return setKeyword(content, keyword);
    },
    isNew() {
      return checkNewPost(this.data.createdAt);
    },
  },
};
</script>
<style scoped></style>
